// -----------------------------------------------------------------------------
// Global Components
// -----------------------------------------------------------------------------
import formValidation from './components/form-validation';
import siteHeader from './components/site-header';
import findCommunityForm from './components/find-community-form';
import mobileNav from './components/mobile-nav';
import carousel from './components/carousel';
import videoCarousel from './components/video-carousel';
import pageIntroNav from './components/page-intro/page-intro-nav';
import stickyNav from './components/js-sticky-nav';
import searchResults from './components/search/search-results';
import recentlyViewed from './components/recently-viewed';
import awardsCarousel from './components/awards-carousel';
import carouselThreeWide from './components/carousel-three-wide';
import carouselSimple from './components/carousel-simple';
import tabcordion from './components/tabcordion';
import tabContentSlider from './components/tab-content-slider';

// -----------------------------------------------------------------------------
// Home Page Components
// -----------------------------------------------------------------------------
import experienceBrightview from './components/home/experience-brightview';
import homeHeroFeatured from './components/home/home-hero-featured';

// -----------------------------------------------------------------------------
// Find Community Components
// -----------------------------------------------------------------------------
import findCommunity from './components/find-community/find-community';
import findCommunityFilters from './components/find-community/find-community-filters';

// -----------------------------------------------------------------------------
// Blog Landing Components
// -----------------------------------------------------------------------------
import BlogFaceting from './components/blog-landing/blog-faceting';

// -----------------------------------------------------------------------------
// Blog Detail Components
// -----------------------------------------------------------------------------
import blogSharebar from './components/blog-detail/blog-sharebar';

// -----------------------------------------------------------------------------
// Community Common Components
// -----------------------------------------------------------------------------
import communityMap from './components/community-common/community-map';
import communityFacebookPost from './components/community-common/community-facebook-post';
import communityFacebookEvents from './components/community-common/community-facebook-events';
import communityScheduleVisit from './components/community-common/community-schedule-visit';

// -----------------------------------------------------------------------------
// Community Landing Components
// -----------------------------------------------------------------------------
import communityLandingNearby from './components/community-landing/community-landing-nearby';
import communityLandingHero from './components/community-landing/community-landing-hero';
import communityLandingHeroFeatures from './components/community-landing/community-landing-hero-features';
import communityLandingColumns from './components/community-landing/community-landing-columns';

// -----------------------------------------------------------------------------
// Support & Resources Components
// -----------------------------------------------------------------------------
import anyResponsiveNav from './plugins/any-responsive-nav';
import resourcesStickyNav from './components/support-resources/resources-sticky-nav';

// -----------------------------------------------------------------------------
// Modal Dialog Hubspot Form
// -----------------------------------------------------------------------------
import gatedPricingHSForm from './components/modals/gated-pricing';

(($) => {

  // Document Ready
  $(() => {

    // High Priority Components
    siteHeader();
    mobileNav();
    carousel();
    videoCarousel();
    experienceBrightview();
    homeHeroFeatured();
    pageIntroNav();
    searchResults();
    blogSharebar();
    recentlyViewed();
    awardsCarousel();
    carouselThreeWide();
    carouselSimple();
    tabcordion();
    tabContentSlider();
    gatedPricingHSForm();

    if ($('#community-map').length) {
      findCommunity();
      findCommunityFilters();
    }

    if ($('.community-map-container').length) {
      communityMap();
    }

    if ($('.blog-landing-wrapper').length) {
      new BlogFaceting().init();
    }

    communityFacebookPost();
    communityFacebookEvents();
    communityLandingNearby();
    communityLandingHero();
    communityLandingHeroFeatures();
    communityLandingColumns();

    anyResponsiveNav();
    resourcesStickyNav();

    // Low Priority Components that don't control layout/functionality on page load
    stickyNav();
    communityScheduleVisit();
    findCommunityForm();
    formValidation();

  });

  String.prototype.trunc = function(n) {
    return this.substr(0, n - 1) + (this.length > n ? '&hellip;' : '');
  };

})($);
